export default "__VITE_ASSET__c0f28086__"